<script setup lang="ts">
import { useGlobalStore } from "~/stores/globalStore";
const globalStore = useGlobalStore();
import { defineAsyncComponent } from "vue";

useHead({
  htmlAttrs: {
    lang: "en",
  },
  title:
    "Professional Software Products, Web and Mobile Application Development Company - Delhi, India",
  meta: [
    {
      name: "description",
      content:
        "WebReinvent Technologies Pvt Ltd is India's most process oriented software, web & mobile app development company. Our ambit of service encompasses and is as vivid as web applications, crm, erp, hrm, api and hybrid mobile applications development.",
    },
    {
      name: "keywords",
      content:
        "software development, web application, api development, portal development, laravel development, crm development, product engineering, product development, saas product development",
    },
  ],
  script: [
    {
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "Professional Software Products, Web and Mobile Application Development Company - Delhi, India",
        url: "https://webreinvent.com/",
        description:
          "WebReinvent Technologies Pvt Ltd is India's most process oriented software, web & mobile app development company. Our ambit of service encompasses and is as vivid as web applications, crm, erp, hrm, api and hybrid mobile applications development.",
        inLanguage: "en",
        publisher: {
          "@type": "Organization",
          name: "WebReinvent Technologies Pvt Ltd",
          url: "https://webreinvent.com/",
          logo: {
            "@type": "ImageObject",
            url: "https://webreinvent.com/images/logo.webp",
          },
          address: {
            "@type": "PostalAddress",
            streetAddress: "Delhi",
            addressCountry: "IN",
          },
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "customer support",
            email: "info@webreinvent.com",
            telephone: "+91-XXXXXXXXXX",
          },
          sameAs: [
            "https://www.linkedin.com/company/webreinvent/",
            "https://twitter.com/webreinvent",
            "https://www.facebook.com/webreinvent",
          ],
        },
        mainEntity: [
          {
            "@type": "Product",
            name: "VaahCMS",
            description:
              "VaahCMS is a web application development platform built with Laravel 10, Vue 3 with structured (HMVC) Modules & Themes.",
            url: "https://vaah.dev/cms",
          },
          {
            "@type": "Product",
            name: "VaahSaaS",
            description:
              "VaahSaaS is a module for multi-tenancy, multi-database SaaS product development for VaahCMS.",
            url: "https://vaah.dev/saas",
          },
          {
            "@type": "Product",
            name: "VaahFlutter",
            description:
              "Flutter scaffolding with essential and common functionalities to kick start the mobile app development.",
            url: "https://vaah.dev/flutter",
          },
          {
            "@type": "Product",
            name: "VaahNuxt",
            description:
              "Build frontend Nuxt 3 and VaahCMS API. Shipped with Nuxt 3, FlowBite, Tailwind CSS and Pinia.",
            url: "https://vaah.dev/nuxt",
          },
          {
            "@type": "Product",
            name: "VaahCRM",
            description:
              "VaahCRM solution, with advanced analytics and customizable workflows is here to revolutionize how you engage and retain your customers.",
            url: "https://vaah.dev/cms",
          },
        ],
        offers: [
          {
            "@type": "Service",
            name: "Product Engineering",
            description:
              "End-to-end enterprise product development & integration.",
            url: "https://webreinvent.com/services/development-services/product-engineering",
          },
          {
            "@type": "Service",
            name: "Vue Js Development",
            description: "Turn your ideas into competitive business solutions.",
            url: "https://webreinvent.com/services/frameworks/vuejs-development-services",
          },
          {
            "@type": "Service",
            name: "eCommerce Development",
            description:
              "We create custom eCommerce applications for exceptional UX.",
            url: "https://webreinvent.com/services/development-services/ecommerce-development",
          },
          {
            "@type": "Service",
            name: "CMS Development",
            description: "Offers secure, flexible, and efficient CMS.",
            url: "https://webreinvent.com/services/development-services/cms-development",
          },
          {
            "@type": "Service",
            name: "Mobile App Development",
            description: "In a mobile-first world, engagement matter most.",
            url: "https://webreinvent.com/services/development-services/mobile-app-development",
          },
          {
            "@type": "Service",
            name: "API Development",
            description: "We build custom apps to bring your ideas to life.",
            url: "https://webreinvent.com/services/development-services/api-development",
          },
          {
            "@type": "Service",
            name: "MVP Development",
            description:
              "Test, gather feedback, save costs, and launch quickly.",
            url: "https://webreinvent.com/services/development-services/mvp-development",
          },
          {
            "@type": "Service",
            name: "AI-Powered Services",
            description:
              "Machine Learning, NLP, Speech-to-Text, Computer Vision, Assisted Video Object Tracking.",
            url: "https://webreinvent.com/services/ai",
          },
        ],
        review: [
          {
            "@type": "Review",
            reviewRating: {
              "@type": "Rating",
              ratingValue: "5",
              bestRating: "5",
            },
            author: {
              "@type": "Person",
              name: "Verified Client",
            },
            reviewBody:
              "Webreinvent is trusted by leading organisations to enhance their development and operational efficiency.",
          },
        ],
      }),
    },
  ],
});

definePageMeta({
  layout: "home-layout",
});

const WrVaahCms = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahCms.vue")
);
const WrVaahSaas = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahSaas.vue")
);
const WrVaahFlutter = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahFlutter.vue")
);
const WrVaahNuxt = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahNuxt.vue")
);
const WrVaahCli = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahCli.vue")
);
const WrVaahAi = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahAi.vue")
);
const WrVaahStore = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahStore.vue")
);
const WrProductEng = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrProductEng.vue")
);
const WrApiDev = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrApiDev.vue")
);
const WrVueJs = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVueJs.vue")
);
const WrEcommerce = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrEcommerce.vue")
);
const WrCmsDev = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrCmsDev.vue")
);
const WrAppDev = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrAppDev.vue")
);
const WrMobileAppDev = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrMobileAppDev.vue")
);
const WrMVPDev = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrMVPDev.vue")
);
const WrVaahCRM = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahCRM.vue")
);
const WrVaahLeads = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahLeads.vue")
);
const WrVaahInbox = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahInbox.vue")
);
const WrVaahHRM = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahHRM.vue")
);

const tabs = ref([
  {
    title: "Open Source",
    content: [
      {
        svg: markRaw(WrVaahCms),
        description:
          "VaahCMS is a web application development platform built with Laravel 10, Vue 3 with structured (HMVC) Modules & Themes.",
        link: "https://vaah.dev/cms",
        label: "vaahcms",
      },
      {
        svg: markRaw(WrVaahSaas),
        description:
          "VaahSaaS is a module for multi-tenancy, multi-database SaaS product development for VaahCMS.",
        link: "https://vaah.dev/saas",
        label: "vaahsaas",
      },
      {
        svg: markRaw(WrVaahFlutter),
        description:
          "Flutter scaffolding with essential and common functionalities to kick start the mobile app development.",
        link: "https://vaah.dev/flutter",
        label: "vaahflutter",
      },
      {
        svg: markRaw(WrVaahNuxt),
        description:
          "Build frontend Nuxt 3 and VaahCMS API. Shipped with Nuxt 3, FlowBite, Tailwind CSS and Pinia.",
        link: "https://vaah.dev/nuxt",
        label: "vaahnuxt",
      },
      {
        svg: markRaw(WrVaahCli),
        description:
          "Command Line Interface (CLI) to generate Packages, Themes, Modules & CRUD Scaffolding in seconds.",
        link: "https://vaah.dev/cli",
        label: "vaahcli",
      },
      {
        svg: markRaw(WrVaahStore),
        description:
          "Free & open-source headless E-commerce platform built on top of Laravel and Vue",
        link: "https://vaah.dev/store",
        label: "vaahstore",
      },
    ],
    value: "0",
  },
  {
    title: "Enterprise Product",
    content: [
      {
        svg: markRaw(WrVaahCRM),
        description:
          "VaahCRM solution, with advanced analytics and customizable workflows is here to revolutionize how you engage and retain your customers.",
        link: "https://vaah.dev/crm",
        label: "vaahcrm",
      },
      {
        svg: markRaw(WrVaahLeads),
        description:
          "VaahLeads is the ultimate solution for boosting your sales pipeline and customer acquisition efforts.",
        link: "https://vaah.dev/leads",
        label: "vaahleads",
      },
      {
        svg: markRaw(WrVaahInbox),
        description:
          "The comprehensive solution designed to simplify and improve your email workflow.",
        link: "https://vaah.dev/inbox",
        label: "vaahinbox",
      },
      {
        svg: markRaw(WrVaahHRM),
        description:
          "VaahHRM is a cutting edge software solution designed to streamline HR process and boost productivity in your Organization.",
        link: "https://vaah.dev/hrm",
        label: "vaahhrm",
      },
    ],
    value: "1",
  },
]);

const content = ref([
  {
    svg: markRaw(WrProductEng),
    title: "Product Engineering",
    description:
      "We offer end-to-end enterprise product development & integration.",
    link: "/services/development-services/product-engineering",
  },
  {
    svg: markRaw(WrVueJs),
    title: "Vue Js Development",
    description: "Turn your ideas into competitive business solutions.",
    link: "/services/frameworks/vuejs-development-services",
  },
  {
    svg: markRaw(WrEcommerce),
    title: "eCommerce Development",
    description: "We create custom eCommerce applications for exceptional UX.",
    link: "/services/development-services/ecommerce-development",
  },
  {
    svg: markRaw(WrCmsDev),
    title: "CMS Development",
    description: "Offers secure, flexible, and efficient CMS.",
    link: "/services/development-services/cms-development",
  },
  {
    svg: markRaw(WrAppDev),
    title: "Application Development",
    description: "Delivering tailored solution for business growth.",
    link: "/services/development-services/application-development",
  },
  {
    svg: markRaw(WrMobileAppDev),
    title: "Mobile App Development",
    description: "In a mobile-first world, engagement matter most.",
    link: "/services/development-services/mobile-app-development",
  },
  {
    svg: markRaw(WrApiDev),
    title: "API Development",
    description: "We build custom apps to bring your ideas to life.",
    link: "/services/development-services/api-development",
  },
  {
    svg: markRaw(WrMVPDev),
    title: "MVP Development",
    description: "Test, gather feedback, save costs, and launch quickly",
    link: "/services/development-services/mvp-development",
  },
]);

const { isMobile } = useDevice();

const visible = ref(false);

const openModal = () => {
  visible.value = true;
};
</script>

<template>
  <div class="z-10 relative">
    <WrHero />
  </div>

  <div class="z-20 relative">
    <section
      class="relative z-20 py-10 lg:py-20 overflow-hidden grid place-items-center"
    >
      <div class="max-w-screen-xl mx-auto px-4 w-full">
        <h2 class="text-center mb-10">
          <WrGradientText
            text="Agile software development"
            append-class=" pb-0 lg:pb-4"
          />
          <p class="text-lg text-[var(--foreground)] tracking-[0.5px]">
            ai trained model on laravel, nuxt, vue and vaahcms
          </p>
        </h2>

        <div class="lg:px-20">
          <WrAgile />

          <div class="w-full flex flex-col items-center p-4 mt-8 lg:mt-16">
            <h2
              class="font-semibold text-[var(--foreground)] text-lg md:text-2xl text-center mb-7"
            >
              Deployment
            </h2>
            <WrDeployment />
          </div>
        </div>
      </div>
    </section>

    <!-- Revolutionising development with AI -->
    <section class="relative z-10 pb-10 lg:grid lg:place-items-center px-4">
      <div
        class="opacity-30 size-[1220px] rounded-full absolute left-1/2 -top-[87%] -translate-x-1/2 bg-[image:var(--bg-circle-spotlight)] shadow-lg"
      ></div>
      <div
        class="size-[790px] bg-[var(--background-glow)] blur-[200px] rounded-full absolute -top-[38%] left-1/2 -translate-x-1/2"
      ></div>
      <div class="relative z-20">
        <h2 class="text-center">
          <WrGradientText
            text="Revolutionising development with AI"
            append-class=" pb-0 lg:pb-4"
          />
          <p class="text-lg tracking-[0.5px] font-anvtgrade-book">
            Unlock new possibilities with AI-powered innovation.
            <br class="hidden lg:block" />
            Elevate efficiency, insights, and growth with our tailored solutions
          </p>
        </h2>
      </div>
      <div class="-my-10 lg:-mt-32 lg:-mb-48 relative z-10">
        <video autoplay loop muted playsinline width="1149">
          <source src="/images/ai.webm" type="video/mp4" />
        </video>
        <div
          v-if="$colorMode.preference != 'dark' && !isMobile"
          class="absolute top-20 left-1/2 -translate-x-1/2 w-1/2 h-40 rounded-full blur-[10px] z-10 bg-[linear-gradient(0deg,_#EAEAEA55_10%,_#EAEAEA_60%)] opaticity-50"
        ></div>
        <div
          v-if="$colorMode.preference != 'dark' && !isMobile"
          class="absolute bottom-20 left-1/2 -translate-x-1/2 w-1/2 h-40 rounded-full blur-[10px] z-10 bg-[linear-gradient(0deg,_#eaeaea00_40%,_#eaeaea_90%)] opaticity-50"
        ></div>
      </div>

      <LazyWrAiServices />
      <WrButton link="/services/ai" container-class="z-10 relative mx-auto"
        >Explore more AI services</WrButton
      >
    </section>

    <section
      class="relative pt-10 lg:pt-20 overflow-visible grid place-items-center px-4"
    >
      <div
        v-if="$colorMode.preference == 'dark'"
        class="absolute w-[2266px] h-[1241px] top-20 rounded-[100%] bg-[linear-gradient(0deg,_#1F013405_31.11%,_#4D27B600_51.33%,_#855BF200_57.98%,_#22206D20_62.05%)] dark:bg-[linear-gradient(0deg,_#1F0134_31.11%,_#4D27B600_51.33%,_#855BF200_57.98%,_#22206D_62.05%)] blur-[100px] dark:blur-[100px]"
      >
        <div
          class="w-[2390px] h-[1863px] bg-white dark:bg-[var(--color-5)] rounded-[100%] absolute top-[200px] left-0"
        ></div>
      </div>
      <NuxtImg
        v-if="$colorMode.preference != 'dark'"
        src="/images/cms-back.webp"
        class="absolute -top-[15rem] left-1/2 -translate-x-1/2 min-w-[2950px] min-h-[2152px]"
        height="2152"
        width="2950"
        alt="cms-back"
        loading="lazy"
        format="webp"
      />

      <div class="rising-stars top-0">
        <div style="height: 4px; width: 4px" q:key="0"></div>
        <div style="height: 2px; width: 2px" q:key="1"></div>
        <div style="height: 1px; width: 1px" q:key="2"></div>
      </div>

      <div class="relative z-20">
        <h2 class="text-center">
          <p class="font-medium leading-tight">
            Use
            <WrVaahCms
              class="text-[var(--foreground)] inline-block"
              :width="isMobile ? 200 : 244"
              :height="isMobile ? 40 : 50"
            />
            to build anything
          </p>
          <WrGradientText
            text="Or everything."
            append-class=" pt-0 pb-4 md:pb-8 "
          />
          <p
            class="text-lg text-[var(--foreground)] tracking-[0.5px] font-anvtgrade-book"
          >
            VaahCMS is a web application development platform
            <br class="hidden lg:block" />
            Built with Laravel 10, Vue 3 with structured (HMVC) Modules &
            Themes.
          </p>
        </h2>

        <LazyWrCmsSection />
      </div>
    </section>

    <section
      class="relative z-20 pt-10 lg:pt-20 overflow-hidden grid place-items-center max-w-screen-xl mx-auto px-4"
    >
      <h2 class="text-center">
        <WrGradientText text="Our products" append-class=" py-0 lg:pb-4" />
      </h2>
      <Tabs value="0" class="my-4 md:my-7">
        <TabList
          unstyled
          :pt="{
            tabList: {
              class:
                '*:selected_tab dark:aria-selected:*:text-white aria-selected:*:!text-[#501d71] dark:aria-selected:*:!text-white *:!text-[#838385] dark:*:!text-[#6950AA] flex justify-center bg-transparent border-b-0',
            },
            activeBar: { class: 'hidden' },
          }"
        >
          <Tab unstyled v-for="tab in tabs" :key="tab.title" :value="tab.value">
            {{ tab.title }}
          </Tab>
        </TabList>

        <TabPanels unstyled class="bg-transparent pt-8">
          <TabPanel
            v-for="tab in tabs"
            :key="tab.value"
            :value="tab.value"
            unstyled
          >
            <div
              class="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-7"
            >
              <div
                v-for="(product, index) in tab.content"
                :key="index"
                class="bg-[image:var(--border-product-card)] rounded-xl p-px"
              >
                <Card
                  unstyled
                  class="p-4 md:p-7 bg-[var(--color-5)] text-[var(--primary)] text-sm h-full rounded-xl relative"
                >
                  <template #title>
                    <component
                      :is="product.svg"
                      class="mb-4 text-[var(--foreground)] w-[90%] max-w-max"
                    />
                  </template>
                  <template #content>
                    <p class="m-0">{{ product.description }}</p>
                    <NuxtLink
                      :aria-label="product.label"
                      :to="product.link"
                      target="_blank"
                      class="absolute z-10 block size-full inset-0"
                    />
                  </template>
                </Card>
              </div>
            </div>
          </TabPanel>
        </TabPanels>
      </Tabs>
      <WrButton @click="openModal">Schedule a Demo</WrButton>
    </section>

    <section
      class="relative pt-10 lg:pt-20 overflow-hidden max-w-screen-xl mx-auto px-4 z-20"
    >
      <h2 class="text-center mb-11">
        <WrGradientText text="Trusted for excellence and efficiency" />
        <p class="text-lg text-[var(--foreground)] font-anvtgrade-book">
          Webreinvent is trusted by leading organisations to enhance their
          development and operational efficiency.
        </p>
      </h2>
      <!-- Carousel Section -->
      <WrTestimonialCardCarousel />
      <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7"
        >View All</WrButton
      >
    </section>

    <section
      class="relative pt-10 lg:pt-20 grid place-items-center z-10 max-w-screen-xl mx-auto px-4"
    >
      <div
        class="rotate-[0deg] rounded-full absolute size-[1200px] opacity-50 -top-[140%] -right-[25%] bg-[image:var(--bg-circle-tailored)]"
      ></div>
      <!-- <div
        class="rounded-full absolute retation-[75deg] size-[1220px] opacity-60 -top-52 -left-[35%] bg-[image:var(--bg-circle-tailored-sm)]">
      </div> -->
      <div class="relative z-10">
        <h2 class="text-center mb-8">
          <WrGradientText
            text="Tailored solutions for growth"
            append-class=" pb-4"
          />
          <p class="text-lg text-[var(--foreground)] font-anvtgrade-book">
            From Product Engineering to Mobile, CMS, API, and Scalable Business
            Growth.
          </p>
        </h2>
        <div class="relative">
          <div
            class="grid max-sm:max-w-[350px] mx-auto max-sm:place-content-left sm:grid-cols-2 lg:grid-cols-4 gap-x-2 gap-y-6"
          >
            <LazyWrTailored :content="content" />
          </div>

          <!-- <div class="max-sm:hidden flex justify-between pointer-events-none absolute top-0 w-full h-full">
            <div v-for="i in 6"
              class="h-full w-px bg-[#E1B8FF] dark:bg-[#1A2132] last:absolute last:top-1/2 last:w-full last:h-px last:dark:bg-[#1A2132]">
            </div>
          </div> -->
        </div>
        <WrButton
          @click="openModal"
          container-class="max-w-max mx-auto mt-7 cursor-pointer"
          link="/services"
          >View all services</WrButton
        >
      </div>
    </section>

    <section class="py-10 lg:py-20 grid place-items-center relative">
      <div
        class="size-[818px] absolute -top-1/2 bg-[#47116B] blur-[240px] opacity-10 dark:opacity-50"
      ></div>
      <div class="relative z-10 w-full">
        <div
          class="opacity-50 rotate-[-60deg] size-[297px] rounded-full bg-[image:var(--bg-circle-contact)] left-1/2 -translate-x-[70%] top-[25%] absolute shadow-sm"
        ></div>
        <h2 class="text-center z-10 relative">
          <p class="text-lg font-anvtgrade-book">Want to collaborate?</p>
          <WrGradientText
            text="Let's have a chat"
            append-class="text-3xl lg:text-[48px] py-4 bg-[linear-gradient(92.15deg,_#12DBFF_35.57%,_#BA55FE_55.72%)]"
          />
        </h2>

        <div
          class="absolute -translate-x-1/2 text-center w-full lg:max-w-xl left-1/2 top-20 mt-5 px-4 z-30"
        >
          <LazyWrAnimatedIntroSection />

          <WrButton
            container-class="max-w-max mx-auto mt-16 z-30 relative"
            @click="openModal"
            >Let's Connect</WrButton
          >
        </div>
        <LazyWrContact />
      </div>
    </section>
  </div>
  <WrContactFormPopup :isOpen="visible" @close="visible = false" class="z-30" />
</template>
